export enum ApiKeyCapabilityEnum {
  MEDICINE_EQUIVALENCY = 'MEDICINE_EQUIVALENCY',
  CREATE_APPOINTMENTS = 'CREATE_APPOINTMENTS',
  LIST_APPOINTMENTS = 'LIST_APPOINTMENTS',
}
